import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["teamOption", "continueButton"]
  }

  toggleTeamOption() {
    const isTeamOptionSelected = this.teamOptionTargets.filter(target => target.checked).length > 0
    this.continueButtonTarget.disabled = !isTeamOptionSelected
    this.continueButtonTarget.classList.remove("disabled")
  }
}
